import React from 'react'
import { Link, withRouter } from 'react-router-dom'

import XText from '../XText/XText'
import SquareWidget from '../SquareWidget/SquareWidget'
import Button from '../Button/Button'

import { useCustomPagination } from '../../hooks/useCustomPagination'

import { loadIcon } from '../../services/helpers'

import './model-selection.css'

const ModelSelection = ({ models = [] }) => {
  const {
    list,
    prevDisabled,
    prevOnClick,
    nextDisabed,
    nextOnClick,
  } = useCustomPagination({ list: models, per: 8 })

  return (
    <section className='model-selection'>
      <div className='section__content'>
        <div className='section__title'>
          Підбір деталей<XText>за маркою авто</XText>
        </div>
        <div className='flex-container--wrap'>
          {list.map((item) => (
            <Link to={`/catalog?car=${item.value}`} key={item.value}>
              <SquareWidget className='square-widget--transparent square-widget--centered'>
                <img
                  src={loadIcon(`auto/${item.label}.jpeg`)}
                  alt={item.label}
                  height={94}
                  width={94}
                />
              </SquareWidget>
            </Link>
          ))}
        </div>
        <div className='flex-container--bottom-70 flex-container--center'>
          <Button.Arrow left disabled={prevDisabled} onClick={prevOnClick} />
          <Button.Arrow disabled={nextDisabed} onClick={nextOnClick} />
        </div>
      </div>
    </section>
  )
}

export default withRouter(ModelSelection)
